import { Field, Label } from '@headlessui/react';
import { FC, ReactNode } from 'react';

import { MinusIcon } from '../../../../assets/icons/index';
import { Checkbox } from '../../../../components/checkbox/index';
import {
  SortStateCallback,
  useTableSort,
} from '../../../../components/table/hooks/use-table-sort.hook';
import { Table } from '../../../../components/table/index';
import {
  PerksColumn,
  perksColumnOrderMap,
  perksColumnSortMap,
  perksColumnTranslationKey,
} from '../table.types';
import { perkSelectStore } from './table.store';

export type PerksTableProps = {
  children: ReactNode;
  handleSort: SortStateCallback<PerksColumn>;
  recordIds: string[];
};

export const PerksTable: FC<PerksTableProps> = ({ children, handleSort, recordIds }) => {
  const [columnsWithSortTitle] = useTableSort<PerksColumn>(
    Object.keys(perksColumnSortMap),
    perksColumnTranslationKey,
    handleSort,
  );

  const isStoreEmpty = perkSelectStore(({ isStoreEmpty }) => isStoreEmpty());
  const selectAll = perkSelectStore(({ selectId }) => selectId);
  const removeAll = perkSelectStore(({ removeId }) => removeId);

  return (
    <div className="h-full w-full overflow-x-auto">
      <Table
        columnOrder={perksColumnOrderMap}
        columnsTitle={{
          ...columnsWithSortTitle,
          [PerksColumn.CHECKBOX]: (
            <Field className="flex w-fit cursor-pointer items-center">
              <Checkbox
                checked={!isStoreEmpty}
                id="select-all"
                onChange={(checked) => (checked ? selectAll(recordIds) : removeAll())}
                selectIcon={<MinusIcon />}
              />
              <Label
                className="absolute left-0 top-0 h-full w-full cursor-pointer"
                htmlFor="select-all"
              />
            </Field>
          ),
          [PerksColumn.ACTIONS]: null,
        }}
        tHeadClassNames={{
          contentClassName: {
            [PerksColumn.CHECKBOX]: 'pl-3',
            [PerksColumn.ACTIONS]: 'justify-end',
          },
        }}
      >
        {children}
      </Table>
    </div>
  );
};
